<template>
  <div class="layout__wrapper">
    <section class="billing-details">
      <div class="container">
        <BillingNotifications :billing="billing" />

        <div class="plan-payment">
          <PlanInfoMonthly
            v-if="billing.plan.id === 'plan_monthly'"
            :billing="billing"
          />
          <PlanInfoAnnual
            v-if="billing.plan.id === 'plan_annual'"
            :billing="billing"
          />
        </div>

        <div v-if="billing.cancel_at_period_end" class="billing-cancel">
          <p class="billing-cancel__text">
            Want to reactivate your Shortform subscription?
            <a
              class="billing-cancel__link"
              :href="billing.paymentProviderSettingsUrl"
              target="_blank"
              @click="Mixpanel.trackCancelSubscriptionClick()"
            >
              <span>
                {{ paymentProviderSettingsText }}
              </span> </a
            >.
          </p>
        </div>
        <div v-else class="billing-cancel">
          <p class="billing-cancel__text">
            Want to stop your Shortform subscription?
            <a
              class="billing-cancel__link"
              :href="billing.paymentProviderSettingsUrl"
              target="_blank"
              @click="Mixpanel.trackCancelSubscriptionClick()"
            >
              <span>
                {{ paymentProviderSettingsText }}
              </span> </a
            >.
          </p>
        </div>
      </div>
    </section>
    <InfoQuestions />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { BillingView } from '@/models/billing'

import PlanInfoMonthly from './BillingDataPaid.PlanInfo.Monthly.vue'
import PlanInfoAnnual from './BillingDataPaid.PlanInfo.Annual.vue'
import InfoQuestions from './InfoQuestions.vue'

import BillingNotifications from './BillingNotifications.vue'
import { Mixpanel } from '@/analytics/mixpanel'

const props = defineProps<{
  billing: BillingView
}>()

const paymentProviderSettingsText = computed(() => {
  if (props.billing.billing_type === 'apple') {
    return 'Please use Apple UI to manage your subscription.'
  }
  return 'Manage your subscription on Google Play.'
})
</script>
